import React from 'react';
import { NumberInputSmall } from 'Packages/FacetDesign/Components';
import moment from 'moment/moment';
import { getStartOfDayLocalFromUTC } from 'Helpers/DateTime';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';

export const AgeDateDisplay = ({
  value, label, onChange, startAge, dateField,
  ...rest
}) => {
  const { resource } = useMetaLayoutContext();

  const startDate = moment(getStartOfDayLocalFromUTC(startAge)).startOf('month');
  const [date, setDate] = React.useState(moment(getStartOfDayLocalFromUTC(resource.attr(dateField))));

  const onAgeChange = (val) => {
    const numericVal = +val;
    const hasNoValue = Number.isNaN(numericVal) || val === null;
    if (hasNoValue) {
      return;
    }

    setDate(moment(startDate).add(numericVal, 'years'));
  };

  return (
    <NumberInputSmall
      {...rest}
      value={value}
      label={label}
      helperTextValue={`${date.format('MMMM YYYY')}`}
      onChange={(val) => {
        onChange(val);
        onAgeChange(val);
      }}
    />
  );
};

AgeDateDisplay.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  startAge: PropTypes.string,
  dateField: PropTypes.string,
};

AgeDateDisplay.defaultProps = {
  value: undefined,
  label: undefined,
  startAge: undefined,
  dateField: undefined,
};
